import { Alert } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import TranslatedSpan from '../../common/components/translated.span';
import translate from '../../common/functions/translate';

export default function AccountUpdated(props) {
   return <>
      <Div
         isContainer={true}
         paddingySM={1}
         paddingyMD={2}
         paddingyLG={3}
         paddingyXL={4}>
         
         <Div isRow={true}>
            <Div cols={12}>
               <H1>
                  <TranslatedSpan english={'Your account is updated'}/>
               </H1>
            </Div>
         </Div>
         
         <Div isRow={true}>
            <Div cols={12} colsSM={12} colsMD={10} colsLG={9} colsXL={8}>
               <Div>
                  <Alert heading={translate('You\'re all set!')}
                         variation="success"
                         hideIcon={true}>
                     <p className="ds-c-alert__text">
                        <TranslatedSpan english={'You can start using your account.'}/>
                     </p>
                  </Alert>
               </Div>
            </Div>
         </Div>

         <Div
            isRow={true}
            paddingBottom={3}
            paddingTop={3}
         >
            <Div cols={5} colsSM={5} colsMD={4} colsLG={3} colsXL={3}>
               <Button
                  color={'teal'}
                  displayAs={'button'}
                  fill={'solid'}
                  size={'small'}
                  onClick={() => props.resetLoginFlow() }
               >
                  <TranslatedSpan english={'Go to Account'}/>
               </Button>
            </Div>
         </Div>
      </Div>
   </>
}
